import {
  Button,
  ConfirmDialog,
  DialogTrigger,
  Icon,
  type PressEvent,
  Tooltip,
  TooltipTrigger,
} from '@iconik-io/uad';

type DeleteModalProps = {
  editButtonDisabled?: boolean;
  onDelete: (event: PressEvent) => void;
};

export function DeleteSegment({
  editButtonDisabled,
  onDelete,
}: DeleteModalProps) {
  return (
    <DialogTrigger>
      <TooltipTrigger>
        <Button
          aria-label="Delete comment"
          size="s"
          variant="destructive"
          isDisabled={editButtonDisabled}
          icon={<Icon name="deletion_delete" />}
        />
        <Tooltip>Delete comment</Tooltip>
      </TooltipTrigger>
      <ConfirmDialog
        title="Delete comment"
        confirmButtonLabel="Delete"
        cancelButtonLabel="Cancel"
        onConfirm={onDelete}
        variant="destructive"
        headingIcon={<Icon name="deletion_delete" />}
      >
        Are you sure you want to delete this comment?
      </ConfirmDialog>
    </DialogTrigger>
  );
}
